export default __webpack_public_path__ + "static/media/mailIcon.7a9bc72b.svg";